import React, { memo, useEffect } from 'react';
import { Title } from '@/components/head/title/index.jsx';
import { PointTitle } from '@/components/head/point/index.jsx';
import { Card } from '@/components/ui/card/index.jsx';
import { Graph } from '@/components/ui/graph/index.jsx';
import styles from './result.module.scss';
import { UsequestionsState } from '@/store/atoms/questionsState';
import { UseArticlesState } from '@/store/atoms/articlesState';
import { useInputValuesState } from '../../store/atoms/inputValuesState';

export const ResultPage = memo(() => {
  const { inputValues } = useInputValuesState();
  const { rate, setRate, list, catList } = UsequestionsState();
  const { articlesList } = UseArticlesState();

  console.log('inputValues1', inputValues);

  useEffect(() => {
    setRate(50 / list.length);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const byCatList = catList.map((list) =>
    inputValues.filter((value) => value.term_id === list.term_id)
  );

  console.log('byCatList', byCatList);
  let byCatSum = [];
  let sumNum = null;
  if (byCatList[0].length) {
    byCatSum = byCatList.map((list) => ({
      term_id: list[0].term_id,
      name: list[0].name,
      sum: list
        .map((num) => num.num)
        .reduce((sum, currentValue) => sum + currentValue),
    }));

    console.log('byCatSum', byCatSum);

    sumNum = byCatSum
      .map((list) => list.sum)
      .reduce((total, currentValue) => total + currentValue);
  }

  // console.log('rate', rate);
  const sum = Math.ceil(sumNum * rate);
  // console.log('sum', sum);
  let newGoodList = [];
  let newBadList = [];

  byCatSum.map((item, index) => {
    if (item.sum >= 4) {
      console.log('item >= 4', index);
      newGoodList.push(byCatSum[index]);
      return newGoodList;
    } else {
      newBadList.push(byCatSum[index]);
      return newBadList;
    }
  });
  console.log('newGoodList', newGoodList);
  console.log('newBadList', newBadList);
  console.log('articlesList', articlesList);

  let articlesByCatItem = [];
  let articlesByCat = [];

  newBadList.filter((cat) => {
    articlesByCatItem = articlesList.filter((item) => {
      // console.log('item', item);
      const idMatchitem = item.measure_cat.filter((id) => {
        // console.log('id', id);
        return id === cat.term_id;
      });
      // console.log('idMatchitem', idMatchitem);
      return idMatchitem.length > 0;
    });
    // console.log('articlesByCatItem', articlesByCatItem);

    articlesByCat.push(...articlesByCatItem);
    return articlesByCat;
  });

  console.log('articlesByCat', articlesByCat);

  let matchArticlesList = Array.from(
    new Map(articlesByCat.map((article) => [article.id, article])).values()
  );
  console.log('matchArticlesList', matchArticlesList);

  let message = '';

  if (sum <= 30) {
    message =
      '改善が必要な点数です。<br>ぜひらくっとデジタル化ができる「BMクラウド」にご相談ください。';
  } else if (sum > 30 && sum <= 50) {
    message =
      'デジタル化はまだ進んでいないようです。<br>改善点を見直して業務効率化を目指しましょう。<br>らくっとデジタル化ができる「BMクラウド」にご相談ください。';
  } else if (sum > 50 && sum <= 90) {
    message =
      '平均以上の点数です！<br>建物管理業務のデジタル化が進んでいますね。<br>改善点を見直してさらにデジタル化を目指しましょう。';
  } else if (sum > 90 && sum <= 100) {
    message =
      '素晴らしい！<br>情報管理、連絡・情報共有、働き方、営業活動、業務効率の全てのデジタル化が進められています。';
  }

  return (
    <>
      <div className={styles.inner}>
        <Title>診断結果</Title>
        <h3 className={styles.title}>あなたの会社のDX指数</h3>
        <div className={styles.point}>
          <span className={styles.color}>{sum}</span>/100点
        </div>
        <div
          className={styles.text}
          dangerouslySetInnerHTML={{ __html: message }}
        ></div>
        <div className={styles.divider}></div>
        <div className={styles.graph}>
          <Graph byCatSum={byCatSum} />
          <div className={styles.graph_contents}>
            <PointTitle backColor={'#333'}>強み</PointTitle>
            <div className={styles.graph_text}>
              {newGoodList.map((item) => {
                return `${item.name} / `;
              })}
            </div>
            <PointTitle backColor={'#4A96E6'}>改善点</PointTitle>
            <div className={`${styles.graph_text} ${styles.color}`}>
              {newBadList.map((item) => {
                return `${item.name} / `;
              })}
            </div>
          </div>
        </div>
      </div>
      {matchArticlesList.length > 0 && (
        <div className={styles.inner}>
          <Title>BMクラウドを用いた解決策</Title>
          {/* <TitleH3>見出しが入ります。</TitleH3>
          <BodyText>
            本文がはいります。本文がはいります。本文がはいります。本文がはいります。本文がはいります。
          </BodyText> */}
          <div className={styles.card}>
            {matchArticlesList.map((article) => (
              <Card
                title={article.acf.problem.title}
                image={article.thumbnail_url}
                link={article.link}
                key={article.id}
              >
                {/* {article.acf.problem.body} */}
              </Card>
            ))}
          </div>
        </div>
      )}
    </>
  );
});
